export function setQueryParam(
  params: URLSearchParams,
  key: string,
  value: string | null | undefined,
): void {
  if (value === null || value === undefined || value === '') {
    params.delete(key)
    return
  }
  params.set(key, value)
}

export function parseBooleanParam(value: string | null): boolean | undefined {
  if (value === 'true' || value === 'active' || value === '1') {
    return true
  }
  if (value === 'false' || value === 'inactive' || value === '0') {
    return false
  }
  return undefined
}

export function parseCsvParam(value: string | null): string[] {
  if (!value) {
    return []
  }
  return value
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean)
}
